// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1HPWF","title":"AfterBackImages_title__3E7wP","images":"AfterBackImages_images__ruLRO"};